import CadastrosAdicionais from '@/enums/cadastros-adicionais';
import { ErpCamposIntegracao } from 'px-business-components';

const mapCadastroAdicionalAlcadaCasaShopping = criterio => ({
  ...criterio,
  description: 'Centro de custo filho',
});

const mapCadastroAdicionalAlcadaSeniorMega = (criterio) => {
  if (criterio.key === CadastrosAdicionais.keys.CONTA_FINANCEIRA.key) {
    return {
      ...criterio,
      description: 'Classe financeira',
    };
  }
  return {
    ...criterio,
  };
};

export const mapCadastroAdicionalAlcadaByErp = (erp, criterio) => {
  if (erp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return mapCadastroAdicionalAlcadaCasaShopping(criterio);
  }
  if (erp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return mapCadastroAdicionalAlcadaSeniorMega(criterio);
  }
  return {
    ...criterio,
  };
};

export default {
  mapCadastroAdicionalAlcadaByErp,
};
